<div class="section-wrap mb-0">
    <div class="section-card">
        <div class="row">
            <div class="col-md-4  col-xs-12">
                <div class="section-wrap mb-0">
                    <h3 class="panel-widget-title">Información</h3>
                    <div style="margin:20px;" class="single-team">
                        <img width="350px" src="{{data.imageUrl}}" alt="Image">
                    </div>
                    <div style="margin:20px;">
                    <label><strong>Nombre: </strong>{{data.names}} {{data.surnames}}</label><br>
                    <label><strong>Acceso: </strong>{{data.role}}</label><br>
                    <label><strong>Email: </strong>{{data.email}}</label><br>
                    <label><strong>Telefono: </strong>{{data.phone}}</label><br>
                    <label><strong>Edad: </strong>{{data.dob | age }} años</label><br>
                    <label><strong>Cuenta Activada: </strong>{{data.activation_Date | utcToLocal}}</label><br>
                    <label><strong>Ultimo Inicio: </strong>{{data.last_Login | timeAgo }}</label><br>
                    <br>
                    <button type="button" class="btn btn-outline-danger" (click)="logout()">
                        <i class="fa-solid fa-right-from-bracket"></i>
                        Cerrar Sesión
                    </button>

                </div>
                </div>
            </div>
            <div class="col-md-8 col-xs-12">
                <div class="section-wrap mb-0">
                    <h3 class="panel-widget-title">Actividad</h3>
                  
                </div>
            </div>
        </div>
    </div>
</div>


